import stoneService from '@services/magento/stone.service';

import { Shipment, ShipmentResponse } from '@stone/interfaces';
import { normalizeParams } from '@stone/searchCriteria';

export async function fetchShipmentsApi(params: any = {}): Promise<{ items: Shipment[]; totalCount: number }> {
  const response: ShipmentResponse = await stoneService.getStoneShipments(normalizeParams(params));
  return {
    items: response.items || [],
    totalCount: response.total_count || 0,
  };
}

export async function fetchShipmentByIdApi(id: number | string): Promise<Shipment> {
  return await stoneService.getStoneShipmentById(id);
}

export async function saveShipmentApi(data: Partial<Shipment>): Promise<Shipment> {
  return await stoneService.saveStoneShipment(data);
}

export async function shipShipmentApi(data: Partial<Shipment>): Promise<Shipment> {
  return await stoneService.stoneShipmentShip(data);
}
